import { render } from "./client-enrolments-overview.vue?vue&type=template&id=0522b317&ts=true"
import script from "./client-enrolments-overview.ts?vue&type=script&lang=ts&external"
export * from "./client-enrolments-overview.ts?vue&type=script&lang=ts&external"

import "./client-enrolments-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__